/**
 * 全局应用配置映射文件
 * 读取系统环境变量或提供合理的默认值
 */
export default () => ({
  port: parseInt(process.env.PORT, 10) || 3000,
  llm: {
    ollamaBaseUrl: process.env.OLLAMA_BASE_URL || 'http://127.0.0.1:11434',
    openaiBaseUrl: process.env.OPENAI_BASE_URL || 'https://api.openai.com/v1',
  },
});
